import { inject, Injectable } from '@angular/core';
import {
  ApiClient,
  LoginAuthCodeRequest,
  InternalUserLoginRequest,
  AuthenticatedUser,
  RefreshSessionRequest,
  NewPasswordRequest,
} from '@pgaoc/shared-lib';
import { Observable } from 'rxjs';
import { Endpoints } from './endpoints';

@Injectable({
  providedIn: 'root',
})
export class InternalAuthApi {
  private apiClient = inject(ApiClient);

  login(request: InternalUserLoginRequest): Observable<AuthenticatedUser> {
    return this.apiClient.post<AuthenticatedUser>(Endpoints.InternalUserAuth.login(), request);
  }

  resetPassword(email: string): Observable<void> {
    return this.apiClient.get<void>(Endpoints.InternalUserAuth.resetPassword(email));
  }

  submitMFACode(request: LoginAuthCodeRequest): Observable<AuthenticatedUser> {
    return this.apiClient.post<AuthenticatedUser>(Endpoints.InternalUserAuth.login(), request);
  }

  setNewPassword(email: string, request: NewPasswordRequest) {
    return this.apiClient.post<void>(Endpoints.InternalUserAuth.setNewPassword(email), request);
  }

  refreshSession(req: RefreshSessionRequest, currentUser: AuthenticatedUser): Observable<AuthenticatedUser> {
    return this.apiClient.post<AuthenticatedUser>(
      Endpoints.InternalUserAuth.refreshSession(currentUser.email ?? ''),
      req,
    );
  }
}
